import memoizeOne from 'memoize-one'
import { useConnect } from 'redux-bundler-hook'

import config from '~/src/App/config'
import createLogger from '~/src/Lib/Logging'
import safeStorage from '~/src/Lib/safeStorage'
import { EMPTY_ARRAY, EMPTY_OBJECT } from '~/src/Lib/Utils'

const storage = safeStorage()
/* istanbul ignore next */
const notProd = process.env.NODE_ENV !== 'production' || config.ENVIRONMENT !== 'production'
const getMergedPermissions = memoizeOne((mine, test) => ({ ...mine, ...test }))
const logger = createLogger('Can/utils')

export const getTestPermissions = () => {
  let testPermissions
  /* istanbul ignore else */
  if (notProd) {
    const storedPermissions = storage.getItem('testPermissions')
    if (storedPermissions) {
      try {
        testPermissions = JSON.parse(storedPermissions)
      } catch (error) /* istanbul ignore next */ {
        console.warn(error)
      }
    }
  }
  return testPermissions
}

export const permitted = (myPermissions = EMPTY_OBJECT, actions = EMPTY_ARRAY, any = false) => {
  let permissions = myPermissions
  /* istanbul ignore else */
  if (notProd) {
    const testPermissions = getTestPermissions()
    if (testPermissions) {
      permissions = getMergedPermissions(myPermissions, testPermissions)
    }
  }
  const requiredPermissions = Array.isArray(actions) ? actions : Array.of(actions)
  logger.debug({ effectivePermissions: permissions, requiredPermissions, any })
  return requiredPermissions[any ? 'some' : 'every'](action => {
    const can = typeof action === 'function' ? action(permissions) : Boolean(permissions?.[action])

    return can
  })
}

export const usePermissions = () => {
  const { myPermissions } = useConnect('selectMyPermissions')
  const testPermissions = getTestPermissions()
  if (notProd && testPermissions) {
    return getMergedPermissions(myPermissions, testPermissions)
  }
  return myPermissions
}

export const useCan = (actions, any) => {
  const { myPermissions } = useConnect('selectMyPermissions')
  if (!actions.length) return true
  return permitted(myPermissions, actions, any)
}
